export const parsePrice = (
  input: string | number | null | undefined
): number => {
  if (!input) return 0;
  if (typeof input === "string") return parseFloat(input);
  return Number(input);
};

export const shouldFlushCompareAtPrice = (
  price: string | number | null | undefined,
  compareAtPrice: string | number | null | undefined
): boolean => {
  return !!compareAtPrice && parsePrice(compareAtPrice) <= parsePrice(price);
};

/**
 * Calculates the per-unit dollar discount for a percentage discount,
 * matching Shopify's rounding behavior (floor to nearest cent).
 *
 * Shopify floors per-unit discounts before multiplying by quantity,
 * e.g. 10% off $23.99 = floor($2.399) = $2.39 per unit.
 */
export function shopifyPercentageDiscountPerUnit(
  unitPrice: number,
  percentage: number
): number {
  return Math.floor(unitPrice * (percentage / 100) * 100) / 100;
}
